import { all, put, takeEvery } from 'redux-saga/effects';
import { SET_GLOBAL, ERASE_BUFFER_GLOBAL } from './constants';
import { setGlobalsuccess, eraseBufferGlobalSucees } from './actions';

/**
 *
 * @param actionObject
 * @returns {IterableIterator<PutEffect<{obj, type}>>}
 */
function* onsetGlobal( actionObject ) {
    if ( actionObject ) {
        yield put( setGlobalsuccess( actionObject ) );
    }
};

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchsetGlobal() {
    yield takeEvery( SET_GLOBAL, onsetGlobal );
};

/**
 *
 * @returns {IterableIterator<PutEffect<{type: string}>>}
 */
function* eraseBufferGlobal() {
    yield put( eraseBufferGlobalSucees() );

};

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchErraseBufferGlobal() {
    yield takeEvery( ERASE_BUFFER_GLOBAL, eraseBufferGlobal );
};

/**
 *
 * @returns {IterableIterator<AllEffect<IterableIterator<ForkEffect>>>}
 */
function* setGlobal() {
    yield all( [
        watchsetGlobal(),
        watchErraseBufferGlobal()
    ] );
}

export default setGlobal;
